import { JOINING_APP_ROUTES } from "../config/common";

// This will ensure that the app is always served from the correct base path
if (
  !window.location.pathname.includes(process.env.PUBLIC_URL) &&
  window.location.pathname !== JOINING_APP_ROUTES.LEGACY_JOIN
) {
  window.history.replaceState(
    "",
    "",
    process.env.PUBLIC_URL + window.location.pathname
  );
}
